/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, InputGroup, Badge,
  Button, Collapse,
} from 'reactstrap';
import {
  Table, Thead, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';
import 'react-image-lightbox/style.css';
import { withTranslation, Trans } from 'react-i18next';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Lightbox from 'react-image-lightbox';
// import BaseGrid from '../../components/Common/BaseGrid';

import { useScanner } from '../../utilities/ScannerContext';

import { get, post } from '../../helpers/api_helper';

const INSPECTION_CART_STORAGE_KEY = 'inspectionCartId';
const NO_CART_ID = 'NO CART';

const getStoredCartId = () => {
  try {
    const storedCartId = localStorage.getItem(INSPECTION_CART_STORAGE_KEY);

    if (storedCartId === null) return null;

    return storedCartId.trim().toUpperCase() || NO_CART_ID;
  } catch (error) {
    return null;
  }
};

const formatOrderedTime = (value) => {
  const date = new Date(value);

  if (!value || Number.isNaN(date.getTime())) return '—';

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const parsePartSticker = (label) => ({
  prefix: label.substring(0, 15),
  serial: label.substring(15, 75).replace(',', '').trim(),
  lot: label.substring(75).trim(),
});

const createPartSticker = (stockId) => ({
  prefix: `|${stockId.trim().substring(0, 8).padEnd(8, ' ')}${'1'.padEnd(4, ' ')}  `,
  serial: '',
  lot: '',
});

const buildPartSticker = (sticker, serial, lot) => {
  const serialField = serial.replace(/,/g, '').trim().substring(0, 60).padEnd(60, ' ');

  return `${sticker.prefix}${serialField}${lot.trim()}`;
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Inspect(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const {
    connectScanner, registerListener, removeListener,
  } = useScanner();

  const history = useHistory();
  const location = useLocation();
  const query = useQuery();

  const { t } = props;

  const [refresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [listeners, setListeners] = useState(false);
  const [stockId, setStockId] = useState(null);
  const [stockScanVersion, setStockScanVersion] = useState(0);
  const [stockInput, setStockInput] = useState('');
  const [scannedSticker, setScannedSticker] = useState(null);
  const [stickerSerial, setStickerSerial] = useState('');
  const [stickerLot, setStickerLot] = useState('');
  const [stickerDetailsOpen, setStickerDetailsOpen] = useState(false);
  const [stickerPrinting, setStickerPrinting] = useState(false);
  const [cartId, setCartId] = useState(getStoredCartId);
  const [cartInput, setCartInput] = useState(() => getStoredCartId() || '');
  const searchRef = useRef(null);
  const itemRequestRef = useRef(0);
  const possibleOrdersRequestRef = useRef(0);
  const [item, setItem] = useState(null);
  const [possibleOrders, setPossibleOrders] = useState([]);
  const [possibleOrdersLoading, setPossibleOrdersLoading] = useState(false);
  const [possibleOrdersError, setPossibleOrdersError] = useState(false);
  const [isGalleryZoom, setisGalleryZoom] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);
  const [parentId, setParentId] = useState(null);

  const submitCartId = (value) => {
    const enteredCartId = value.trim().replace(/^-/, '').toUpperCase();
    const nextCartId = enteredCartId || NO_CART_ID;

    setCartId(nextCartId);
    setCartInput(nextCartId);
    localStorage.setItem(INSPECTION_CART_STORAGE_KEY, nextCartId);
  };

  const handleScan = (label) => {
    if (label !== null && label !== undefined) {
      if (label.startsWith('|') && label.length > 74) {
        // part scanned
        const nextStockId = label.substring(1, 9).trim();
        const nextSticker = parsePartSticker(label);

        itemRequestRef.current += 1;
        possibleOrdersRequestRef.current += 1;
        setItem(null);
        setGalleryImages([]);
        setPossibleOrders([]);
        setPossibleOrdersError(false);
        setPossibleOrdersLoading(false);
        setScannedSticker(nextSticker);
        setStickerSerial(nextSticker.serial);
        setStickerLot(nextSticker.lot);
        setStickerDetailsOpen(false);
        setStockInput(nextStockId);
        setStockId(nextStockId);
        setStockScanVersion((currentVersion) => currentVersion + 1);
        return;
      }

      if (label.startsWith('-') && label.length > 3) {
        // cart scanned; keep it active until another cart is scanned
        submitCartId(label);
      }
    }
  };

  const submitStockId = (value) => {
    const nextStockId = value.trim();

    if (nextStockId !== '') {
      setScannedSticker(null);
      setStickerSerial('');
      setStickerLot('');
      setStickerDetailsOpen(false);
      setStockInput(nextStockId);
      setStockId(nextStockId);
    }
  };

  // Connect to the scanner when the component mounts
  useEffect(() => {
    registerListener(handleScan);
    setListeners(true);
  }, [connectScanner]);

  const loadItem = async (id) => {
    if (id !== null) {
      const requestId = itemRequestRef.current + 1;
      itemRequestRef.current = requestId;
      setLoading(true);
      setItem(null);
      setGalleryImages([]);
      try {
        const itm = await get(`/api/warehouse/inspect/item/${id}`);

        if (itm !== '') {
          const imgs = [];

          if (itm.items !== undefined) {
            itm.items.forEach((nitm) => {
              nitm.images.forEach((img) => {
                const iim = { ...img };
                iim.label = `${nitm.part_number} - ${iim.label}`;
                imgs.push(iim);
              });
            });
          } else if (itm.images !== undefined) {
            itm.images.forEach((img) => {
              imgs.push(img);
            });
          }

          if (itemRequestRef.current === requestId) {
            if (itm.items !== undefined) setParentId(itm.stock_id);
            setGalleryImages(imgs);
            setItem(itm);
          }
        } else if (itemRequestRef.current === requestId) {
          toastr.error('Item not found');
          setStockInput('');
          setStockId(null);
        }
      } catch (e) {
        if (itemRequestRef.current === requestId) toastr.error('Error loading data');
      } finally {
        if (itemRequestRef.current === requestId) setLoading(false);
      }
    }
  };

  const loadPossibleOrders = async (activeStockId, activeCartId) => {
    const requestId = possibleOrdersRequestRef.current + 1;
    possibleOrdersRequestRef.current = requestId;
    setPossibleOrders([]);
    setPossibleOrdersError(false);
    setPossibleOrdersLoading(true);

    try {
      const filter = encodeURIComponent(
        `pi.cart=${activeCartId}&pi.stock_id=${activeStockId}&pi.void=0`,
      );
      const data = await get(`/api/warehouse/pick/items?page=1&per=100&f=${filter}`);
      const ordersById = new Map();

      (data?.results || []).forEach((pickItem) => {
        (pickItem.order_items || []).forEach((orderItem) => {
          const { order } = orderItem;

          if (!order?.id) return;

          const existingOrder = ordersById.get(order.id) || {
            id: order.id,
            orderedAt: order.ordered_at,
            qty: 0,
            reference: order.reference || order.id,
            slots: [],
            void: Number(order.void) === 1,
          };

          existingOrder.qty += Number(orderItem.link_qty || 0);
          if (pickItem.slot && !existingOrder.slots.includes(pickItem.slot)) {
            existingOrder.slots.push(pickItem.slot);
          }
          ordersById.set(order.id, existingOrder);
        });
      });

      if (possibleOrdersRequestRef.current === requestId) {
        setPossibleOrders([...ordersById.values()].sort((first, second) => (
          new Date(first.orderedAt || 0) - new Date(second.orderedAt || 0)
        )));
      }
    } catch (error) {
      if (possibleOrdersRequestRef.current === requestId) setPossibleOrdersError(true);
    } finally {
      if (possibleOrdersRequestRef.current === requestId) setPossibleOrdersLoading(false);
    }
  };

  useEffect(() => {
    if (stockId !== null && stockId.startsWith('|') && stockId.length > 10) {
      setStockId(stockId.substring(1, 9).trim());
    } else if (stockId !== null && cartId !== null) {
      loadItem(stockId);
      if (cartId !== NO_CART_ID) {
        loadPossibleOrders(stockId, cartId);
      } else {
        possibleOrdersRequestRef.current += 1;
        setPossibleOrders([]);
        setPossibleOrdersError(false);
        setPossibleOrdersLoading(false);
      }
    } else if (stockId === null || cartId === null) {
      itemRequestRef.current += 1;
      possibleOrdersRequestRef.current += 1;
      setLoading(false);
      setItem(null);
      setGalleryImages([]);
      setPossibleOrders([]);
      setPossibleOrdersError(false);
      setPossibleOrdersLoading(false);
    }
  }, [stockId, cartId, stockScanVersion]);

  useEffect(() => {
    const sid = query.get('sid');

    setScannedSticker(null);
    setStickerSerial('');
    setStickerLot('');
    setStickerDetailsOpen(false);
    if (sid !== null) {
      setStockId(sid);
    } else {
      setStockId(parentId);
    }
  }, [location]);

  useEffect(() => {
    const handleWindowFocus = () => {
      // Add listeners with a slight delay to avoid any re-registration issues
      if (!listeners) {
        registerListener(handleScan);
      }
    };

    const handleWindowBlur = async () => {
      // Remove listeners immediately when the window loses focus
      setStockId(null); // Clear stockId when the back button is used
      setStockInput('');
      setScannedSticker(null);
      setStickerSerial('');
      setStickerLot('');
      setStickerDetailsOpen(false);
      removeListener();
      setListeners(false);
    };

    // Initial listener registration
    handleWindowFocus();
    searchRef.current?.focus();

    // Cleanup listeners on component unmount
    return () => {
      handleWindowBlur();
    };
  }, []);

  useEffect(() => {
    if (cartId !== null && stockId === null) searchRef.current?.focus();
  }, [cartId, stockId]);

  const details = (d) => (
    <React.Fragment key={d.id}>
      <div className="float-end">
        <Button
          className="fs-5"
          color="link"
          onClick={() => {
            if (d.stock_id !== stockId) {
              history.push(`?sid=${d.stock_id}`);
            }
          }}
        >
          {d.stock_id}
        </Button>
      </div>
      <h5>{`${d.manufacturer} ${d.part_number}`}</h5>

      {d.alert !== null && d.alert !== '' && d.alert !== undefined && (
        <div className="alert alert-danger mt-3 mb-3" role="alert">
          {d.alert.trim()}
        </div>
      )}

      {d.boardNumbers !== undefined && d.boardNumbers.length > 0 && (
        <div>
          <h6>{t('Board Numbers')}</h6>

          <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'scroll' }}>
            <Table className="table table-sm table-nowrap table-bordered table-centered table-hover mb-0">
              <Thead>
                <Tr className="table-warning">
                  <Th>{t('Label')}</Th>
                  <Th>{t('Value')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {d.boardNumbers.map((bn) => (
                  <Tr key={bn.id}>
                    <Td>{bn.label}</Td>
                    <Td>{bn.value}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        </div>
      )}

      {d.tags !== undefined && d.tags.length > 0 && (
        <div className="mt-4 mb-4">
          <h6>{t('Tags')}</h6>

          {d.tags.map((tag) => (
            <Badge key={tag.id} className="m-1" color="primary">{tag.label}</Badge>
          ))}
        </div>
      )}
    </React.Fragment>
  );

  const devices = (d) => (
    <div>
      {d.devices !== undefined && d.devices.length > 0 && (
        <Card>
          <CardHeader className="bg-transparent border-bottom">
            {t('Device Information')}
          </CardHeader>

          <CardBody>
            <div className="table-responsive">
              <Table className="table table-nowrap table-bordered table-centered table-hover mb-0">
                <Thead>
                  <Tr className="table-warning">
                    <Th>{t('Brand')}</Th>
                    <Th>{t('Model')}</Th>
                    <Th>{t('Versions')}</Th>
                    <Th>{t('Title')}</Th>
                    <Th>{t('Type')}</Th>
                    <Th>{t('Production Year')}</Th>
                    <Th>{t('Market Country')}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {d.devices.map((dev) => (
                    <Tr key={dev.id}>
                      <Td>{dev.brand}</Td>
                      <Td>{dev.model}</Td>
                      <Td>{dev.version}</Td>
                      <Td>{dev.marketing_title}</Td>
                      <Td>{`${dev.product_type} ${dev.product_sub_type}`}</Td>
                      <Td>{dev.production_year}</Td>
                      <Td>{dev.market_country}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      )}
    </div>
  );

  const hasInspectionContext = stockId !== null && cartId !== null;

  const clearCart = () => {
    setCartId(null);
    setCartInput('');
    localStorage.removeItem(INSPECTION_CART_STORAGE_KEY);
  };

  const clearStockId = () => {
    itemRequestRef.current += 1;
    possibleOrdersRequestRef.current += 1;
    setStockId(null);
    setStockInput('');
    setScannedSticker(null);
    setStickerSerial('');
    setStickerLot('');
    setStickerDetailsOpen(false);
    searchRef.current?.focus();
  };

  const printableSticker = scannedSticker || (stockId ? createPartSticker(stockId) : null);

  const reprintSticker = async () => {
    if (!printableSticker) return;

    setStickerPrinting(true);
    try {
      await post('/api/warehouse/ops/printInspectionSticker', {
        sticker: buildPartSticker(printableSticker, stickerSerial, stickerLot),
        part_number: item?.part_number || item?.sku || '',
      });
      toastr.success(t('Sticker sent to printer'));
    } catch (error) {
      toastr.error(error.message, t('Unable to reprint sticker'));
    } finally {
      setStickerPrinting(false);
    }
  };

  const stockIdCard = (showActiveCart = false) => (
    <Card className="inspection-context-card inspection-context-card--stock shadow-sm">
      <CardHeader className="inspection-context-card__header border-bottom">
        <i className="mdi mdi-barcode-scan me-2" />
        {t('Stock ID')}
      </CardHeader>
      <CardBody>
        <p className="p-0 m-0">
          <Trans>
            Scan or enter the <strong>Stock ID</strong> of the item you would like to inspect
          </Trans>
        </p>

        {showActiveCart && (
          <div className="d-flex align-items-center justify-content-between bg-light rounded p-2 mt-3">
            <div>
              <span className="text-muted me-2">{t('Active cart:')}</span>
              <strong className="fs-5">{cartId}</strong>
            </div>
            <Button
              color="danger"
              size="sm"
              className="btn-soft-danger"
              type="button"
              title={t('Clear cart')}
              aria-label={t('Clear cart')}
              onClick={clearCart}
            >
              <i className="mdi mdi-close-thick" />
            </Button>
          </div>
        )}

        <InputGroup className="mt-3">
          <input ref={searchRef} type="text" className="form-control inspection-context-card__input" placeholder="Stock ID" value={stockId || stockInput} readOnly={stockId !== null} onChange={(e) => setStockInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') submitStockId(e.target.value); }} />
          {stockId === null && (
            <button className="btn inspection-context-card__scan" type="button" onClick={() => { submitStockId(searchRef.current.value); }}>
              <i className="mdi mdi-barcode-scan" />
            </button>
          )}
          {stockId !== null && (
            <button className="btn btn-danger btn-soft-danger" type="button" onClick={clearStockId}>
              <i className="mdi mdi-close-thick" />
            </button>
          )}
        </InputGroup>
      </CardBody>
    </Card>
  );

  const inspectionCartCard = () => (
    <Card className="inspection-context-card inspection-context-card--cart shadow-sm">
      <CardHeader className="inspection-context-card__header border-bottom">
        <i className="mdi mdi-cart-outline me-2" />
        {t('Inspection Cart')}
      </CardHeader>
      <CardBody>
        <p className="p-0 m-0">
          <Trans>
            Scan or enter the <strong>Cart ID</strong> you would like to inspect
          </Trans>
        </p>
        <InputGroup className="mt-3">
          <input
            type="text"
            className="form-control inspection-context-card__input"
            placeholder={t('Optional Cart ID')}
            value={cartId || cartInput}
            readOnly={cartId !== null}
            onChange={(e) => setCartInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') submitCartId(e.target.value); }}
          />
          {cartId === null && (
            <button className="btn inspection-context-card__scan" type="button" onClick={() => submitCartId(cartInput)}>
              <i className="mdi mdi-barcode-scan" />
            </button>
          )}
          {cartId !== null && (
            <button className="btn btn-danger btn-soft-danger" type="button" onClick={clearCart}>
              <i className="mdi mdi-close-thick" />
            </button>
          )}
        </InputGroup>
      </CardBody>
    </Card>
  );

  return (
    <div className="page-content inspection-page">
      <div className="container-fluid">
        {!hasInspectionContext && (
          <Row>
            <Col xl="3" />
            <Col xl="6">
              {cartId === null ? inspectionCartCard() : stockIdCard(true)}
            </Col>
          </Row>
        )}

        {hasInspectionContext && (
        <Row>
          <Col xl="4">
            {stockId !== null && item !== null && (
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  {t('Acquired Information')}
                </CardHeader>
                <CardBody>
                  {item.items !== undefined && item.items.map(details)}

                  {item.items === undefined && details(item)}
                </CardBody>
              </Card>
            )}

            <Card>
              <CardHeader className="bg-transparent border-bottom d-flex align-items-center justify-content-between">
                <span>{t('Possible Orders')}</span>
                {!possibleOrdersLoading && !possibleOrdersError && (
                  <Badge color="light" className="text-dark">{possibleOrders.length}</Badge>
                )}
              </CardHeader>
              <CardBody className="p-0">
                <div className="table-responsive">
                  <Table className="table table-sm table-nowrap table-bordered table-centered mb-0">
                    <Thead>
                      <Tr className="table-light">
                        <Th>{t('Order')}</Th>
                        <Th>{t('Ordered')}</Th>
                        <Th>{t('Qty')}</Th>
                        <Th>{t('Slot')}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {possibleOrdersLoading && (
                        <Tr>
                          <Td colSpan="4" className="text-center text-muted py-3">
                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                            {t('Loading...')}
                          </Td>
                        </Tr>
                      )}
                      {!possibleOrdersLoading && possibleOrdersError && (
                        <Tr>
                          <Td colSpan="4" className="text-center text-danger py-3">
                            {t('Unable to load possible orders.')}
                          </Td>
                        </Tr>
                      )}
                      {!possibleOrdersLoading && !possibleOrdersError && cartId === NO_CART_ID && (
                        <Tr>
                          <Td colSpan="4" className="text-center text-muted py-3">
                            {t('No cart selected.')}
                          </Td>
                        </Tr>
                      )}
                      {!possibleOrdersLoading && !possibleOrdersError && cartId !== NO_CART_ID && possibleOrders.length === 0 && (
                        <Tr>
                          <Td colSpan="4" className="text-center text-muted py-3">
                            {t('No matching orders found.')}
                          </Td>
                        </Tr>
                      )}
                      {!possibleOrdersLoading && !possibleOrdersError && possibleOrders.map((order) => (
                        <Tr key={order.id} className={order.void ? 'table-danger' : ''}>
                          <Td>
                            <Link to={`/orders/${order.id}`} target="_blank" rel="noopener noreferrer">
                              {order.reference}
                            </Link>
                            {order.void && (
                              <div className="text-danger fw-bold small">{t('VOID')}</div>
                            )}
                          </Td>
                          <Td>{formatOrderedTime(order.orderedAt)}</Td>
                          <Td>{order.qty}</Td>
                          <Td>{order.slots.length > 0 ? order.slots.join(', ') : '—'}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl="8">
            <Row>
              <Col md="6">{stockIdCard()}</Col>
              <Col md="6">{inspectionCartCard()}</Col>
            </Row>

            <Card>
              <CardHeader className="bg-transparent border-bottom d-flex align-items-center justify-content-between">
                <span>{t('Inspect Item')}</span>
                {printableSticker && (
                  <div className="d-flex align-items-center gap-1">
                    <Button
                      color="secondary"
                      size="sm"
                      type="button"
                      className="inspection-sticker-action inspection-sticker-action--print"
                      disabled={stickerPrinting}
                      title={t('Reprint Sticker')}
                      aria-label={t('Reprint Sticker')}
                      onClick={reprintSticker}
                    >
                      {stickerPrinting
                        ? <span className="spinner-border spinner-border-sm" role="status" />
                        : <i className="mdi mdi-printer" />}
                    </Button>
                    <Button
                      color="secondary"
                      size="sm"
                      type="button"
                      className="inspection-sticker-action inspection-sticker-action--details"
                      title={t('Sticker Details')}
                      aria-label={t('Sticker Details')}
                      aria-expanded={stickerDetailsOpen}
                      onClick={() => setStickerDetailsOpen((isOpen) => !isOpen)}
                    >
                      <i className={`mdi ${stickerDetailsOpen ? 'mdi-chevron-up' : 'mdi-tag-text-outline'}`} />
                    </Button>
                  </div>
                )}
              </CardHeader>
              {printableSticker && (
                <Collapse isOpen={stickerDetailsOpen}>
                  <div className="border-bottom p-3">
                    <Row>
                      <Col md="8">
                        <label className="form-label" htmlFor="inspection-sticker-serial">
                          {t('Serial')}
                        </label>
                        <input
                          id="inspection-sticker-serial"
                          type="text"
                          className="form-control"
                          maxLength="60"
                          value={stickerSerial}
                          onChange={(event) => setStickerSerial(event.target.value)}
                        />
                      </Col>
                      <Col md="4">
                        <label className="form-label" htmlFor="inspection-sticker-lot">
                          {t('Lot')}
                        </label>
                        <input
                          id="inspection-sticker-lot"
                          type="text"
                          className="form-control"
                          value={stickerLot}
                          onChange={(event) => setStickerLot(event.target.value)}
                        />
                      </Col>
                    </Row>
                  </div>
                </Collapse>
              )}
              <CardBody>
                {loading === true && (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">{t('Loading...')}</span>
                    </div>
                  </div>
                )}

                {loading === false && item !== null && (
                  <>
                    <div className="mb-3">
                      <Row>
                        <Col xl="6">
                          <p>{t('Stock ID:')} <strong className="fs-4">{stockId}</strong></p>
                        </Col>
                        <Col xl="6">
                          <p>
                            {t('Part Number/or Kit SKU:')} <strong className="fs-4">{item.part_number !== undefined ? item.part_number : item.sku}</strong>
                          </p>
                        </Col>
                      </Row>
                    </div>

                    <div className="zoom-gallery">
                      {galleryImages.map((img, index) => (
                        <div
                          key={img.id}
                          style={{ height: '400px', width: '48%', overflow: 'hidden' }}
                          className="img-thumbnail d-inline-block m-1 p-2"
                        >
                          <img
                            src={img.url}
                            style={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'contain', // Ensures the image scales proportionally
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setisGalleryZoom(true);
                              setPhotoIndex(index);
                            }}
                            alt=""
                          />
                        </div>
                      ))}
                    </div>

                    {isGalleryZoom ? (
                      <Lightbox
                        mainSrc={galleryImages[photoIndex].url}
                        nextSrc={galleryImages[(photoIndex + 1) % galleryImages.length].url}
                        prevSrc={galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length].url}
                        onCloseRequest={() => {
                          setisGalleryZoom(false);
                        }}
                        onMovePrevRequest={() => {
                          setPhotoIndex((photoIndex + galleryImages.length - 1) % galleryImages.length);
                        }}
                        onMoveNextRequest={() => {
                          setPhotoIndex((photoIndex + 1) % galleryImages.length);
                        }}
                        imageTitle={galleryImages[photoIndex].label}
                      />
                    ) : null}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        )}

        {stockId !== null && item !== null && devices(item)}
      </div>
    </div>
  );
}

Inspect.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Inspect));
